$(function() {
    
  // ANNOUNCEMENT SCROLL ---

  var scrollInt = 5000;
  
  if ($('.announcement-bar__slider').length) {

    // recursive function - return to first announcement ---
    function b2s() {
      if ($('.announcement-bar__content-nav--left').hasClass('announcement-bar__content-nav--disabled') == false){
          $('.announcement-bar__content-nav--left').click();
          b2s();
      }	
    }
  		
    setInterval(function () {

      // check if the announcement bar is being hover / focus - skip scroll ---
      if ($('.announcement-bar__content:hover, .announcement-bar__content:focus').length == 0){
      
        // scroll right 1 announcement - if on last announcement scroll back to first ---
        if ($('.announcement-bar__content-nav--right').hasClass('announcement-bar__content-nav--disabled') == false) {
          
          $('.announcement-bar__content-nav--right').click();
        } else {
        
          b2s();
        }
        
      }
      
    }, scrollInt);

  }

  // END ANNOUNCEMENT SCROLL ---

  if($('.template-product').length){
    $('.breadcrumb span:nth-child(3)').html('<a href="/collections/all">Products</a>').css('visibility','visible');

    // RECHARGE REMOVE ONE-TIME PRICE ---
    var recharge_load = setInterval(function(){
      if($('.rc-widget .onetime-radio .rc-radio__label').length){
        var one_time_text = $('.rc-widget .onetime-radio .rc-radio__label').text().split('$')[0];
        $('.rc-widget .onetime-radio .rc-radio__label').text(one_time_text);
        clearInterval(recharge_load);
      }
    }, 150);
    
  }
  

});